import { render, staticRenderFns } from "./add_user.vue?vue&type=template&id=ca20a48a"
import script from "./add_user.vue?vue&type=script&lang=js"
export * from "./add_user.vue?vue&type=script&lang=js"
import style0 from "./add_user.vue?vue&type=style&index=0&id=ca20a48a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports